// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__17BCo","errors":"Errors_errors__3vMnM"};